export default "__VITE_ASSET__227ff053__"